(ns frontend.view.modals.account-reactivate.events
  (:require
   [clojure.string :as string]
   [common.email :as email]
   [frontend.state.account :as account]
   [frontend.view.modals.components.processing-modal :as processing-modal]))

(defn form-ready?
  [state account role]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (and (not (string/blank? first-name))
         (not (string/blank? last-name))
         (not (string/blank? email))
         (email/valid-email-pattern? email))))


(defn unsaved-changes?
  [state account role]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (or (not= email (:account/email account))
        (not= first-name (:account/first-name account))
        (not= last-name (:account/last-name account))
        (not= role-kw role))))

(defn toggle-set
  [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn modify-modules!
  [state kw val]
  (swap! state update kw toggle-set val))

(defn re-activate-account!
  [state account-id role-id send-email? close! on-submit!]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (processing-modal/start-processing! state)
    (account/update-account!
     (fn [_]
       (processing-modal/success! state)
       (when on-submit!
         (on-submit!)))
     (fn [err]
       (partial processing-modal/error! state))
     {:db/id              account-id
      :account/email      email
      :account/first-name first-name
      :account/last-name  last-name}
     {:db/id            role-id
      :common/disabled? false
      :role/role        role-kw}
     send-email?)))
